var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Upload", size: "lg" },
      on: {
        ok: _vm.ok,
        hide: _vm.closeHandler,
        shown: _vm.onModalShown,
        hidden: _vm.onModalHidden,
      },
    },
    [
      _c("Vue2Dropzone", {
        ref: "fileInput",
        attrs: { id: "uploadDropzone", options: _vm.dropzoneOptions },
        on: {
          "vdropzone-file-added": _vm.setFiles,
          "vdropzone-removed-file": _vm.setFiles,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }